export default __webpack_public_path__ + "static/media/AH.1a5ea790.svg";